module.exports = __webpack_public_path__ + "img/log_editor_footer.1260d37a.png";